var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('app-breadcrumb',{attrs:{"page-title":_vm.pageTitle,"icon":_vm.pageIcon}}),_vm._v(" "),_c('app-tab',{attrs:{"tabs":_vm.tabs,"icon":_vm.pageIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }